import * as React from "react";
import { Box, Divider, Skeleton } from "@mui/material";
import ViewDetails from "../genericComponents/view-details/ViewDetails";
import {
  BasicProgram,
  ResponseObject,
  ViewDetailsServices,
} from "@/app/classes/main";
import { ApiService } from "@/app/services/AppService";
import { getHubId } from "../genericComponents/helper-functions/currencyCode";
import { SearchServiceMobileCard } from "./SearchServiceMobileCard";
import MaxServiceAlert from "../genericComponents/card/MaxServiceAlert";
import ViewDetailsRsOneContainer from "../genericComponents/view-details/ViewDetailsRsOneContainer";
import AllCartsSlideSearch from "../genericComponents/all-carts/AllCartsSlideSearch";

interface SearchServicesMobileProps {
  serviceName: any;
}

const SearchServicesMobile: React.FC<SearchServicesMobileProps> = ({
  serviceName,
}) => {
  const [open, setOpen] = React.useState(false);
  const [searchServiceList, setSearchServiceList] = React.useState<
    ViewDetailsServices[] | undefined
  >(undefined);
  const [viewDetails, setViewDetails] = React.useState<
    ViewDetailsServices | undefined
  >(undefined);
  const [reloadViewDetailsItem, setReloadViewDetailsItem] =
    React.useState(false);
  const [updateCard, setUpdateCard] = React.useState(false);
  const [openMaxService, setOpenMaxService] = React.useState(false);
  const [openRsOneDetails, setOpenRsOneDetails] = React.useState(false);
  const [viewDetailsRsOneSid, setViewDetailsRsOneSid] = React.useState<
    number | undefined
  >(undefined);
  const apiService = React.useMemo(() => new ApiService(), []);
  const xHubId = getHubId();

  const handleOpenViewCart = (item: any) => {
    setOpen(true);
    setViewDetails(item);
  };

  const handleOpenViewDetailsRsOne = (basicProgram: BasicProgram) => {
    setOpenRsOneDetails(true);
    setViewDetailsRsOneSid(basicProgram?.id);
  };

  const getSearchServicesWithName = React.useCallback(async () => {
    try {
      if (serviceName) {
        const responseObject: ResponseObject | undefined =
          await apiService.get<ResponseObject>(
            apiService.searchServicesWithName + serviceName,
            undefined,
            xHubId
          );
        const response = responseObject?.object;
        setSearchServiceList(response);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }, [apiService, serviceName, xHubId]);

  React.useEffect(() => {
    getSearchServicesWithName();
  }, [serviceName, getSearchServicesWithName]);

  return (
    <React.Fragment>
      <Box
        sx={{
          overflow: "auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        {searchServiceList && searchServiceList.length > 0
          ? searchServiceList?.map((item: any, index: any) => (
              <Box
                key={index}
                onClick={() => handleOpenViewCart(item)}
                sx={{
                  cursor: "pointer",
                  margin: "1rem",
                  boxShadow: "2px 2px 8px 2px rgba(0, 0, 0, 0.2)",
                  borderRadius: "0.5rem",
                }}
              >
                <SearchServiceMobileCard
                  item={item}
                  setReloadViewDetailsItem={(value: any) =>
                    setReloadViewDetailsItem(value)
                  }
                  updateCard={updateCard}
                  setUpdateCard={() => setUpdateCard(false)}
                  setOpenMaxService={setOpenMaxService}
                  handleOpenViewDetailsRsOne={(item: any) =>
                    handleOpenViewDetailsRsOne(item)
                  }
                />
              </Box>
            ))
          : Array.from({ length: 5 }).map((_, i) => (
              <Box
                key={i}
                sx={{
                  margin: "1rem",
                  boxShadow: "2px 2px 8px 2px rgba(0, 0, 0, 0.2)",
                  borderRadius: "0.5rem",
                  padding: "0.5rem",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "center",
                  }}
                >
                  <Skeleton
                    variant="rounded"
                    sx={{
                      margin: "0.5rem",
                      width: "60px",
                      height: "60px",
                    }}
                  />
                  <Box>
                    <Skeleton
                      variant="rectangular"
                      sx={{
                        margin: "0.5rem",
                        width: "200px",
                        height: "25px",
                      }}
                    />
                    <Skeleton
                      variant="rectangular"
                      sx={{
                        margin: "0.5rem",
                        width: "200px",
                        height: "25px",
                      }}
                    />
                  </Box>
                </Box>
                <Skeleton
                  variant="rectangular"
                  sx={{
                    margin: "0.5rem",
                    width: "-webkit-fill-available",
                    height: "50px",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    margin: "0.5rem",
                    width: "-webkit-fill-available",
                    height: "100px",
                  }}
                />
              </Box>
            ))}
        <AllCartsSlideSearch />
      </Box>
      <ViewDetails
        open={open}
        setClose={() => setOpen(false)}
        imageUrl={viewDetails?.coverImage?.secureHttpPath}
        heading={viewDetails?.name}
        servicedDetails={viewDetails?.aboutList}
        descriptions={viewDetails?.descriptions}
        amount={viewDetails?.amount}
        min={viewDetails?.min}
        id={viewDetails?.id}
        cid={viewDetails?.cid}
        subHeading={viewDetails?.subHeading}
        mrp={viewDetails?.mrp}
        specialPrice={viewDetails?.specialPrice}
        specialMessage={viewDetails?.specialMessage}
        coin={viewDetails?.cashbackSalontymCoins}
        aboutList={viewDetails?.aboutList}
        serviceCharge={viewDetails?.serviceCharge}
        productCost={viewDetails?.productCost}
        reloadCartItemsFlag={() => setUpdateCard(true)}
        reloadViewDetailsItem={reloadViewDetailsItem}
        setReloadViewDetailsItem={() => {
          setReloadViewDetailsItem(false);
        }}
      />
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
      <ViewDetailsRsOneContainer
        open={openRsOneDetails}
        handleCloseStoreDialog={() => setOpenRsOneDetails(false)}
        viewDetailsRsOneSid={viewDetailsRsOneSid}
      />
    </React.Fragment>
  );
};

export default SearchServicesMobile;
